module.exports = __webpack_public_path__ + "static/media/bts_lalela_170718_037_small.01205336.jpg";